import { BANNER, BANNER_EDIT, BANNERS, BANNER_IMAGE_UPLOAD, BANNERS_ENABLE, BANNERS_DISABLE,
  BANNERS_EXCLUDE, BANNERS_PAGINATE, NOTIFICATIONS_INCLUDE } from '@store/types'
import axios from 'axios'
import shortly from 'vuex-shortly'
import graphQL from '@graphQL'
import BannersQuery from '@graphQL/queries/Banners'
import BannerQuery from '@graphQL/queries/Banner'
import moment from 'moment'
import toLocaleDate from '@helpers/toLocaleDate'
import imageUpload from '@helpers/fileUpload'

const state = {
  list: [],
  details: {},
  paginate: {}
}

const getters = {
  [BANNERS]: ({ list }) => {
    return list.map(media => {
      const { start_date: start, end_date: end } = media || {}

      const startDate = toLocaleDate(+start)
      const endDate = toLocaleDate(+end)

      const modified = { ...media, start_date: startDate, end_date: endDate }
      return modified
    })
  },
  [BANNER]: ({ details }) => {
    const { start_date: start, end_date: end, blockedCompanies: blocked_companies, company, ...rest } = details || {}

    const startDate = toLocaleDate(+start)
    const endDate = toLocaleDate(+end)
    const modified = { ...rest, start_date: startDate, end_date: endDate, company }
    return modified
  },
  [BANNERS_PAGINATE]: 'paginate'
}

const mutations = {
  [BANNERS]: 'list',
  [BANNER]: 'details',
  [BANNERS_PAGINATE]: 'paginate'
}

const DEFAULT_FORMAT = { in: 'DD/MM/YYYY HH:mm', out: 'YYYY-MM-DD HH:mm:ss' }

const toOptionalDate = (value, format = DEFAULT_FORMAT) => {
  const date = moment(value, format.in)
  if (!date.isValid()) {
    return ''
  }
  return date.format(format.out)
}

const actions = {
  [BANNERS]: async ({ commit }, { changed = false, page = 1, ...payload } = {}) => {
    const response = await graphQL(BannersQuery, { ...payload, page: changed ? 1 : +page })
    const { data: medias, ...paginate } = response?.data?.data?.banners || {}
    commit(BANNERS, medias || [])
    commit(BANNERS_PAGINATE, paginate)
  },

  [BANNER]: async ({ commit }, payload = {}) => {
    const response = await graphQL(BannerQuery, payload)
    const { banner: media } = response?.data?.data || {}
    commit(BANNER, media)
  },

  [BANNER_EDIT]: async ({ state, dispatch }, payload = {}) => {
    const {
      id,
      image,
      partner = '',
      campaign = '',
      account,
      end_date: end,
      start_date: start,
      image_secondary: imageSecondary,
      vidalink,
      ...rest
    } = payload
    if (payload.type !== 0) delete payload.image_secondary

    const urlId = id ? '/' + id : ''

    const modified = {
      ...rest,
      company_id: account || null,
      partner_id: (partner && partner.id) || '',
      campaign_id: (campaign && campaign.id) || '',
      start_date: toOptionalDate(start),
      end_date: toOptionalDate(end),
      vidalink
    }

    const method = id ? 'put' : 'post'

    try {
      const response = await axios[method](`/banner${urlId}`, modified)

      if (response.data.success) {
        const { id } = response.data.data
        await dispatch(BANNER_IMAGE_UPLOAD, { image, imageSecondary, id })

        const message = `Banner ${id ? 'alterado' : 'criado'} com sucesso!`
        dispatch(NOTIFICATIONS_INCLUDE, {
          type: 'success',
          message
        })
      } else {
        const message = `Não foi possível ${id ? 'alterar os dados d' : 'criar '}o banner.`
        dispatch(NOTIFICATIONS_INCLUDE, {
          type: 'error',
          message
        })
      }
      return response
    } catch (error) {
      const message = error.response.data.data || error.response.data.message
      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'error',
        message
      })
      return error
    }
  },

  [BANNER_IMAGE_UPLOAD]: async ({ state }, payload) => {
    const { image, imageSecondary, id } = payload
    const url = '/banner/' + id

    const data = { url }

    if (image !== state.details.image) data.image = image
    if (imageSecondary !== state.details.image_secondary &&
      imageSecondary !== undefined) data.image_secondary = imageSecondary

    let response = false
    if (data.image || data.image_secondary) response = await imageUpload(data)

    return response
  },

  [BANNERS_ENABLE]: async ({ dispatch }, payload) => {
    const banners = payload.map(banner => banner.id)
    await axios.post('/banner/action', {
      action: 'enable',
      items: banners
    }).then((res) => {
      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message: 'Banner(s) ativado(s) com sucesso!'
      })

      return res
    }, () => {
      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'error',
        message: 'Ocorreu um erro!'
      })
      return false
    })
    await dispatch(BANNERS)
  },

  [BANNERS_DISABLE]: async ({ dispatch }, payload) => {
    const banners = payload.map(banner => banner.id)
    await axios.post('/banner/action', {
      action: 'disable',
      items: banners
    }).then((res) => {
      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message: 'Banner(s) desativado(s) com sucesso!'
      })

      return res
    }, () => {
      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'error',
        message: 'Ocorreu um erro!'
      })
      return false
    })
    await dispatch(BANNERS)
  },

  [BANNERS_EXCLUDE]: async ({ dispatch }, payload) => {
    const banners = payload.map(banner => banner.id)
    await axios.post('/banner/action', {
      action: 'delete',
      items: banners
    }).then((res) => {
      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message: 'Banner(s) excluído(s) com sucesso!'
      })

      return res
    }, () => {
      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'error',
        message: 'Ocorreu um erro!'
      })
      return false
    })
    await dispatch(BANNERS)
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/banners.js